(function () {
  const MOBILE_BREAKPOINT = '(max-width: 767px)'; 
  const CTA_VISIBILITY_RATIO = 0.99;
  if (customElements.get('sticky-pdp-cta')) return;

  customElements.define('sticky-pdp-cta', class StickyPdpCta extends HTMLElement {
    constructor() {
      super();
      this._onResize = () => this.applyViewportMode();
      this._onScrollVisibility = () => this.updateStickyVisibilityFromViewport();
    }

    connectedCallback() {
      this.container = this.closest('.sticky-pdp-cta');
      this.mainProduct = document.querySelector('product-info[id^="MainProduct"]');
      if (this.mainProduct) {
        const { productId, section } = this.mainProduct.dataset;
        this.mainQuantityInput =
          this.mainProduct.querySelector(
            `quantity-input[data-product-id="${productId}"][data-section-id="${section}"] .quantity__input[name="quantity"]`
          ) ||
          this.mainProduct.querySelector('.quantity__input[name="quantity"]');
      } else {
        this.mainQuantityInput = null;
      }
      this.variantData = this.getVariantData();
      this.isPersonalizedProduct = this.dataset.isPersonalizedProduct === 'true';
      this.defaultImageUrl = this.dataset.defaultImage || '';
      try {
        this.variantImages = typeof this.dataset.variantImages === 'string' && this.dataset.variantImages ? JSON.parse(this.dataset.variantImages) : {};
      } catch (_) {
        this.variantImages = {};
      }
      const idInput = this.querySelector('[name="id"]');
      if (idInput && this.variantData.length) this.currentVariant = this.variantData.find((v) => v.id === Number(idInput.value));

      document.body.classList.add('sticky-pdp-cta-enabled');
      this.mobileQuery = window.matchMedia(MOBILE_BREAKPOINT);
      this.mobileQuery.addEventListener('change', this._onResize);
      this.applyViewportMode();
      this.observeViewportForMainCta();
      window.addEventListener('scroll', this._onScrollVisibility, { passive: true });
      window.addEventListener('resize', this._onScrollVisibility);
      this.syncQuantityWithMainForm();
      this.syncWithMainProductForm();
      this.setupPersonalizeButton();
      this.updateImage();
      this.updatePrice();
      this.updateButton();
      if (this.isPersonalizedProduct) {
        this.updatePersonalizeVsAtcState();
        this.observeMainAtcButton();
      }
    }

    isElementInViewport(el) {
      if (!el || getComputedStyle(el).display === 'none' || getComputedStyle(el).visibility === 'hidden') return false;
      const rect = el.getBoundingClientRect();
      const viewportTop = 0;
      const viewportBottom = window.innerHeight || document.documentElement.clientHeight || 0;

      const visibleHeight = Math.min(rect.bottom, viewportBottom) - Math.max(rect.top, viewportTop);
      const elementHeight = rect.height || (rect.bottom - rect.top);

      if (elementHeight <= 0) return false;

      const visibleRatio = visibleHeight / elementHeight;
      return visibleRatio > CTA_VISIBILITY_RATIO;
    }

    updateStickyVisibilityFromViewport() {
      const mainAtc = document.querySelector('.f-main-product-form .f-product-form__submit');
      const personalizeBtn = document.querySelector('#personalizeButton');
      const mainAtcInView = this.isElementInViewport(mainAtc);
      const personalizeInView = this.isElementInViewport(personalizeBtn);
      if (mainAtcInView || personalizeInView) {
        this.hideStickyBar();
      } else {
        this.showStickyBar();
      }
    }

    observeViewportForMainCta() {
      const mainAtc = document.querySelector('.f-main-product-form .f-product-form__submit');
      const personalizeBtn = document.querySelector('#personalizeButton');
      const targets = [mainAtc, personalizeBtn].filter(Boolean);
      if (targets.length === 0) return;

      this._ctaInView = { atc: false, personalize: false };
      const updateVisibility = () => {
        const hide = this._ctaInView.atc || this._ctaInView.personalize;
        if (hide) this.hideStickyBar();
        else this.showStickyBar();
      };
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target === mainAtc) this._ctaInView.atc = entry.isIntersecting;
            if (entry.target === personalizeBtn) this._ctaInView.personalize = entry.isIntersecting;
          });
          updateVisibility();
        },
        {
          rootMargin: '0px', 
          threshold: CTA_VISIBILITY_RATIO
        }
      );
      targets.forEach((el) => observer.observe(el));
      this._viewportObserver = observer;
      this.updateStickyVisibilityFromViewport();
    }

    hideStickyBar() {
      if (this.container) this.container.classList.add('f-hidden');
      document.documentElement.style.setProperty('--sticky-pdp-cta-height', '0px');
    }

    showStickyBar() {
      if (this.container) this.container.classList.remove('f-hidden');
      this.updateHeight();
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener?.('change', this._onResize);
      this._viewportObserver?.disconnect();
      window.removeEventListener('scroll', this._onScrollVisibility);
      window.removeEventListener('resize', this._onScrollVisibility);
      this._unsyncQuantity?.();
      document.body.classList.remove('sticky-pdp-cta-enabled');
    }

    getVariantData() {
      const script = this.container?.querySelector('[data-variants]');
      if (!script) return [];
      try { return JSON.parse(script.textContent) || []; } catch (_) { return []; }
    }

    applyViewportMode() {
      this.updateHeight();
      const isMobile = this.mobileQuery.matches;
      this.container.classList.toggle('sticky-pdp-cta--always-visible-mobile', isMobile);
      this.container.classList.add('sticky-pdp-cta--show');
    }

    updateHeight() {
      document.documentElement.style.setProperty('--sticky-pdp-cta-height', this.clientHeight ? `${this.clientHeight}px` : '0px');
    }

    syncQuantityWithMainForm() {
      const stickyForm = this.querySelector('form');
      if (!stickyForm || !this.mainQuantityInput) return;

      const ensureStickyQuantityField = () => {
        let stickyQty = stickyForm.querySelector('input[name="quantity"]');
        if (!stickyQty) {
          stickyQty = document.createElement('input');
          stickyQty.type = 'hidden';
          stickyQty.name = 'quantity';
          stickyForm.appendChild(stickyQty);
        }
        return stickyQty;
      };

      const copyQuantity = () => {
        const qtyField = ensureStickyQuantityField();
        qtyField.value = this.mainQuantityInput.value || '1';
        setTimeout(() => this.updateRegularPriceFromMain(), 50);
      };

      copyQuantity();

      ['change', 'input'].forEach((evtName) => {
        this.mainQuantityInput.addEventListener(evtName, copyQuantity);
      });

      stickyForm.addEventListener('submit', copyQuantity);

      if (window.FoxThemeEvents?.subscribe) {
        const unsubQtyUpdate = window.FoxThemeEvents.subscribe('quantity-update', () => {
          setTimeout(() => this.updateRegularPriceFromMain(), 100);
        });
        const origUnsync = () => {
          ['change', 'input'].forEach((evtName) => {
            this.mainQuantityInput.removeEventListener(evtName, copyQuantity);
          });
          stickyForm.removeEventListener('submit', copyQuantity);
        };
        this._unsyncQuantity = () => { origUnsync(); unsubQtyUpdate(); };
      } else {
        this._unsyncQuantity = () => {
          ['change', 'input'].forEach((evtName) => {
            this.mainQuantityInput.removeEventListener(evtName, copyQuantity);
          });
          stickyForm.removeEventListener('submit', copyQuantity);
        };
      }
    }

    setupPersonalizeButton() {
      const btn = this.querySelector('[data-personalize-trigger]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const target = document.querySelector('#personalizeButton');
        (target || document.querySelector('.f-main-product-form'))?.scrollIntoView({ behavior: 'smooth', block: target ? 'center' : 'start' });
        if (target) setTimeout(() => target.click(), 400);
      });
    }

    updatePersonalizeVsAtcState() {
      const buttonsWrap = this.querySelector('.sticky-pdp-cta__buttons');
      const atcBtn = this.querySelector('.sticky-pdp-cta__atc-btn');
      if (!buttonsWrap || !atcBtn) return;
      const needsPersonalize = document.querySelector('.f-main-product-form .f-product-form__submit')?.classList.contains('background-gray');
      buttonsWrap.classList.toggle('sticky-pdp-cta__buttons--atc-mode', !needsPersonalize);
      atcBtn.classList.toggle('sticky-pdp-cta__atc-btn--pending', needsPersonalize);
    }

    observeMainAtcButton() {
      const mainAtc = document.querySelector('.f-main-product-form .f-product-form__submit');
      if (!mainAtc) return;
      new MutationObserver(() => this.updatePersonalizeVsAtcState()).observe(mainAtc, { attributes: true, attributeFilter: ['class'] });
      if (typeof window.personalizationuiOnSave === 'function') {
        const orig = window.personalizationuiOnSave;
        window.personalizationuiOnSave = () => { orig(); this.updatePersonalizeVsAtcState(); };
      }
    }

    updateButton() {
      const addButton = this.querySelector('form [name="add"]');
      const textEl = addButton?.querySelector('span:not(.f-icon)');
      const s = window.FoxThemeStrings || {};

      if (addButton) {
        if (!this.currentVariant) {
          addButton.disabled = true;
          if (textEl) textEl.textContent = s.unavailable || 'Unavailable';
        } else {
          addButton.disabled = !this.currentVariant.available;
          if (textEl) textEl.textContent = this.currentVariant.available ? (s.addToCart || 'Add to cart') : (s.soldOut || 'Sold out');
        }
      }
      const personalizeBtn = this.querySelector('.sticky-pdp-cta__personalize-btn');
      if (personalizeBtn && this.isPersonalizedProduct) {
        const personalizeText = personalizeBtn.querySelector('span');
        if (personalizeText) {
          personalizeText.textContent = this.currentVariant?.available ? (s.personalize || 'Personalize') : (s.soldOut || 'Sold out');
        }
        personalizeBtn.disabled = !this.currentVariant?.available;
        if (this.currentVariant?.available) {
          personalizeBtn.setAttribute('data-personalize-trigger', '');
        } else {
          personalizeBtn.removeAttribute('data-personalize-trigger');
        }
      }
    }

    getVariantImageUrl(variant) {
      if (!variant) return this.defaultImageUrl;
      const id = variant.id;
      if (this.variantImages && (this.variantImages[id] || this.variantImages[String(id)])) return this.variantImages[id] || this.variantImages[String(id)];
      if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
      return this.defaultImageUrl;
    }

    updateImage() {
      const wrap = this.querySelector('[data-sticky-bar-image]');
      const img = wrap?.querySelector('img');
      if (!img) return;
      const url = this.getVariantImageUrl(this.currentVariant);
      if (!url) return;
      img.src = url;
      img.srcset = url + ' 200w';
    }

    updatePrice() {
      if (!this.currentVariant || typeof queryDomNodes !== 'function' || typeof formatMoney !== 'function') return;
      const nodes = queryDomNodes({
        priceWrapper: '.f-price',
        salePrice: '.f-price-item--sale',
        compareAtPrice: ['.f-price-item--regular'],
        unitPrice: '.f-price__unit',
        unitPriceWrapper: '.f-price__unit-wrapper'
      }, this);
      const { priceWrapper, salePrice, unitPrice, unitPriceWrapper, compareAtPrice } = nodes;
      const { compare_at_price, price, unit_price_measurement } = this.currentVariant;
      const fmt = window.FoxThemeSettings?.money_format ?? '${{amount}}';
      const onSale = compare_at_price && compare_at_price > price;
      if (priceWrapper) {
        priceWrapper.classList.toggle('f-price--on-sale', onSale);
        priceWrapper.classList.toggle('f-price--sold-out', !this.currentVariant.available);
        priceWrapper.classList.remove('visibility-hidden');
      }
      if (salePrice) salePrice.innerHTML = formatMoney(price, fmt);
      if (compareAtPrice?.length) compareAtPrice.forEach((el) => (el.innerHTML = formatMoney(compare_at_price > price ? compare_at_price : price, fmt)));
      if (unit_price_measurement && unitPrice && typeof getBaseUnit === 'function') {
        if (unitPriceWrapper) unitPriceWrapper.classList.remove('hidden');
        unitPrice.classList.remove('f-hidden');
        unitPrice.innerHTML = `<span>${formatMoney(this.currentVariant.unit_price, fmt)}</span>/<span data-unit-price-base-unit>${getBaseUnit(this.currentVariant)}</span>`;
      } else {
        if (unitPriceWrapper) unitPriceWrapper.classList.add('hidden');
        if (unitPrice) unitPrice.classList.add('f-hidden');
      }
      this.updateRegularPriceFromMain();
    }

    syncWithMainProductForm() {
      const variantInput = this.querySelector('[name="id"]');
      if (!window.FoxThemeEvents?.subscribe || !this.mainProduct) return;
      const { variantChange = 'variant-change' } = window.PUB_SUB_EVENTS || {};
      window.FoxThemeEvents.subscribe(variantChange, (evt) => {
        if (!evt?.data?.variant || evt.data.sectionId !== this.mainProduct?.dataset?.section) return;
        const eventVariant = evt.data.variant;
        this.currentVariant = this.variantData?.length
          ? (this.variantData.find((v) => v.id === eventVariant.id) || eventVariant)
          : eventVariant;
        if (variantInput) variantInput.value = this.currentVariant.id;
        this.updateImage();
        this.updatePrice();
        this.updateButton();
        if (this.isPersonalizedProduct) this.updatePersonalizeVsAtcState();
      });
    }

    updateRegularPriceFromMain() {
      try {
        const mainRegularPrice = document.querySelector('.price-quantity-wrap .regular-price');
        if (!mainRegularPrice || !mainRegularPrice.textContent.trim()) return;
        const match = mainRegularPrice.textContent.match(/\$[\d,.]+/);
        if (!match) return;
        const onSale = this.currentVariant?.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price;
        if (onSale) {
          this.querySelectorAll('.f-price-item--sale').forEach(el => {
            el.textContent = match[0];
          });
        } else {
          this.querySelectorAll('.f-price-item--regular').forEach(el => {
            el.textContent = match[0];
          });
        }
      } catch (_) {
      }
    }
  });
})();
